import { useEffect } from 'react';
import axios from 'axios';
import AppRoutes from './routes';
import { useAuthStore } from './store/auth.store';
import { authApi } from './api/auth.api';
import { resolvedBaseUrl } from './api/client';

const App = () => {
  const { setAuth, logout, setAccessToken, setInitializing } = useAuthStore();

  useEffect(() => {
    const restoreSession = async () => {
      try {
        // Call refresh-token with httpOnly cookie — bypasses apiClient so no
        // stored token is needed yet; uses the same base URL as apiClient
        const refreshRes = await axios.post(
          `${resolvedBaseUrl}/auth/refresh-token`,
          {},
          { withCredentials: true }
        );
        const { accessToken } = refreshRes.data.data;

        // Put token in store so the profile request carries it
        setAccessToken(accessToken);

        const profileRes = await authApi.getProfile();
        const user = profileRes.data;

        setAuth(user, accessToken);
      } catch {
        // Cookie missing or expired — user must log in manually
        logout();
      } finally {
        setInitializing(false);
      }
    };

    restoreSession();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <AppRoutes />;
};

export default App;
